import { Label, LabelVisibility } from '@aibees/elephant/types/label';
import { PresetVisibility } from '@aibees/shared/definition';

export function filterLabelsByVisibility(
  labels: Label[],
  tabValue: PresetVisibility
): Label[] {
  if (tabValue === PresetVisibility.PRIVATE) {
    return labels.filter((x) => x.visibility === LabelVisibility.PRIVATE);
  }
  if (tabValue === PresetVisibility.INTERNAL) {
    return labels.filter((x) => x.visibility === LabelVisibility.INTERNAL);
  }
  return labels;
}
